import React, { useEffect, useState ,useRef } from "react";
import "./SetupBox.css";
import { createPortal } from "react-dom";
import A3PackDetails from "./A3PackDetails";

const SetupBox = (props) => {

    const {item,showMaximumChat ,setIsShowMaximumChat} = props
    let data = {};

    if (item?.text) {
      try {
        data = JSON.parse(item.text);
      } catch (e) {
        console.error("Invalid JSON:", e);
      }
    }
    


    const [selectedBox, setSelectedBox] = useState(null);
    const [animateBox, setAnimateBox] = useState(null);
    const [animatePack, setAnimatePack] = useState(false);
    const [modalData, setModalData] = useState(null);


    useEffect(()=>{
        
        data?.boxDetails?.map((box)=>{
            if(box?.isAutoSelected){
                handleSelect(box?.boxNumber)
            }

        })


    },[])

    const handleSelect = (boxNumber) => {
        props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: {
                key1: boxNumber,
                displayName: boxNumber,
            },
        }));

        if (selectedBox === boxNumber) {
          // closing
          setSelectedBox(null);
          sessionStorage.removeItem("selectedBoxNumber");
          setAnimatePack(false);
        } else {
          // opening
          setSelectedBox(boxNumber);
          sessionStorage.setItem("selectedBoxNumber", String(boxNumber));
          setAnimatePack(true);
          setTimeout(() => setAnimatePack(false), 700); // remove after animation
        }
      };
      
    

    const renderOTTLabels = (ch) => {
        const labels = [];
        if (ch.megaChannels) labels.push(`Mega ${ch.megaChannels}`);
        if (ch.megaApps) labels.push(`Apps ${ch.megaApps}`);
        if (ch.flex) labels.push(`Flex ${ch.flex}`);
        if (ch.flexApps) labels.push(`Flex Apps ${ch.flexApps}`);
        return labels.length > 0 ? labels.join(", ") : "-";
    };
    const Modal = ({ children, onClose }) => {
        const ref = useRef();
      
        // useOutsideClick(ref, onClose);
      
        // Prevent clicks inside modal from bubbling to document
        const handleClickInside = (e) => {
          e.stopPropagation();
        };
      
        return createPortal(
          <div className="filter-overlay">
            
            <div className="filter-dropdown-modal" ref={ref} onClick={handleClickInside}>
              {children}
            </div>
          </div>,
          document.body
        );
      };

    return (
        <div style={{overflowY : !showMaximumChat && 'scroll'}} className={`setup-container ${!showMaximumChat ? "shrink-mode" : ""}`}>
            <h3 style={{ width: !showMaximumChat && "max-content" }}className="setup-heading">{data.displayMsg}</h3>

            {/* Table Header */}
            <div
                className="table-header"
                style={{
                    gridTemplateColumns: `50px repeat(${data?.boxHeadings?.length}, 1fr)` ,width: !showMaximumChat && "max-content" 
                }}
            >
                <div></div>
                {data?.boxHeadings?.map((heading, idx) => (
                    <div key={idx}>{heading}</div>
                ))}
            </div>

            {/* Box Details */}
            {data?.boxDetails?.map((box, index) => {
                const detail = box?.singleDetailOfBox || [];
                return (
                    <div
                        key={index}
                        className={`box-detail-row action-tab ${selectedBox === box.boxNumber ? "selected" : ""} ${animateBox === box.boxNumber ? "animate" : ""}`}
                        style={{
                            gridTemplateColumns: `50px repeat(${detail?.length}, 1fr)`,width: !showMaximumChat && "max-content" 
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={selectedBox === box.boxNumber}
                            onChange={() => handleSelect(box.boxNumber)}
                        />
                        {detail?.map((val, i) => (
                            <div
                                key={i}
                                style={{display :'flex'}}
                                className={i === 3 ? "status-green" : ""}
                                dangerouslySetInnerHTML={{ __html: val || "-"}}
                            >
                            </div>
                        ))}
                    </div>
                );
            })}

            {/* Pack Details */}
            {selectedBox && (
                <div className={`pack-container ${animatePack ? "animate-pack" : ""}`}>
                    <h3 className="pack-heading">Pack Details :</h3>

                    {/* Buttons */}
                    <div className="pack-buttons">
                        {data.boxDetails
                            .find((b) => b.boxNumber === selectedBox)
                            ?.packDetails?.buttons?.map((btn, i) => (
                                <button
                                    key={i}
                                    // className={btn.isInput ? "btn-active" : "btn-disabled"}
                                    className={ "btn-active action-tab"}
                                    onClick={() => {
                                      
                                      
                                        // Build latest errors object manually
                                        // const updatedErrors = {
                                        //   ...props?.errors, // old errors
                                        //   [props?.index]: {
                                        //     key1: `${item.value},${subIdInput}`,
                                        //     displayName: `${item.value},${subIdInput}`,
                                        //     selected: true,
                                        //   },
                                        // };
                                      
                                        // // Update state with new object
                                        // props?.setErrors(updatedErrors);
                                      
                                        // Now you can safely use updatedErrors immediately
                                        // const validValues = Object.values(updatedErrors).filter(Boolean);
                                        // const input = validValues.length === 1
                                        // ? validValues[0].key1
                                        // : JSON.stringify(validValues.map(item => item.key1));
                                        // const displayText = validValues.map(item => item.displayName).join(", ");
                                      
                                        if(btn?.isInput){
                                            props?.addMessages(selectedBox, btn?.opcode, btn?.buttonName, btn?.buttonName);
                                        }else if (btn?.isLayOver){
                                            //popup
                                            setIsShowMaximumChat(true)
                                            setModalData(btn?.aaServiceDetails)
                                        }else{
                                            props?.addMessages('', btn?.opcode, btn?.buttonName, btn?.buttonName);
                                        }
                                      
                                      
                                        // Store locally
                                        // localStorage.setItem("inputValue", JSON.stringify({ key1: item.value }));
                                        
                                      }}

                                >
                                    {btn?.buttonName}
                                </button>
                            ))}
                    </div>

                    {/* Dynamic Table */}
                    {(() => {
                        const selected = data.boxDetails.find(
                            (b) => b.boxNumber === selectedBox
                        );
                        const tableData = selected?.packDetails?.data || [];

                        const renderPill = (label, value, colorClass = "pill-default") => {
                            if (value == null) return null;
                            return (
                                <span className={`pill ${colorClass}`}>
                                    {label && <span className="pill-label">{label}</span>}
                                    <div className="pill sub yellow-pill"> {value} </div>
                                </span>
                            );
                        };

                        const renderGroupedPill = (totalLabel, mainValue, subItems = []) => {
                            return (
                                <>
                                {totalLabel && <span style={{fontSize :!props?.showMaximumChat && "12px"}}  className="A3f">{totalLabel}</span>}
                                <span className="pill-group">
                                    {mainValue != null && <span>{mainValue}</span>}
                                    {subItems.map((s, i) => (
                                        <span key={i} className={`pill sub ${s.color || ""}`}>
                                            {s.label} {s.value}
                                        </span>
                                    ))}
                                </span>
                                </>
                            );
                        };

                        const renderCustomGroupedPill = (totalLabel,noOfChannels, mainLabel, subItems = []) => {
                            return (
                                <>
                                {totalLabel && <span style={{fontSize :!props?.showMaximumChat && "12px"}} className="A3f">{totalLabel}</span>}
                                <span className="pill-group">
                                   {noOfChannels && <span style={{marginRight :'8px'}}>{noOfChannels}</span>}
                                    {mainLabel && <span>{mainLabel}</span>}
                                    {subItems.map((s, i) => (
                                        <span key={i} className={`pill sub ${s.color || ""}`}>
                                            {s.label} {s.value}
                                        </span>
                                    ))}
                                </span>
                                </>
                            );
                        };

                        return (
                            <table style={{ width: !showMaximumChat && "max-content" }} className="pack-table">
                                <tbody>
                                    {tableData.map((item, idx) => {
                                        const ch = item.fieldData?.channelCount || {};
                                        return (
                                            <tr key={idx}>
                                                <td className="field-name">{item.fieldName}</td>
                                                <td className="field-values">
                                                    {!ch?.isBingeOTT && ch?.noOfChannels && renderGroupedPill("Total", ch?.noOfChannels, [
                                                        ch.noOfHDChannels && {
                                                            label: "HD",
                                                            value: ch?.noOfHDChannels,
                                                            color: "yellow-pill"
                                                        },
                                                        ch?.noOfSDChannels && {
                                                            label: "SD",
                                                            value: ch?.noOfSDChannels,
                                                            color: "yellow-pill"
                                                        },
                                                        ch?.ott && {
                                                            label: "OTT",
                                                            value: ch?.ott,
                                                            color: "pink-pill"
                                                        }
                                                    ].filter(Boolean))}
                                                    {(ch?.megaChannels || ch?.megaApps) &&
                                                        renderCustomGroupedPill("Total",ch?.noOfChannels,"Mega", [
                                                            ch?.megaChannels && {
                                                                label: "",
                                                                value: ch?.megaChannels,
                                                                color: "yellow-pill"
                                                            },
                                                            ch?.megaApps && {
                                                                label: "Apps",
                                                                value: ch?.megaApps,
                                                                color: "purple-pill"
                                                            }
                                                        ].filter(Boolean))}
                                                    {(ch?.isBingeOTT && (ch?.flex || ch?.flexApps)) &&
                                                        renderCustomGroupedPill("Total",ch?.noOfChannels, "Flexi", [
                                                            ch?.flex && {
                                                                label: "",
                                                                value: ch?.flex,
                                                                color: "yellow-pill"
                                                            },
                                                            ch?.flexApps && {
                                                                label: "Apps",
                                                                value: ch?.flexApps,
                                                                color: "purple-pill"
                                                            }
                                                        ].filter(Boolean))}
                                                    {item?.fieldData?.counter && renderPill("Counter", item?.fieldData?.counter, "pink-pill")}
                                                    { item?.fieldData?.charges && renderPill("Charges", item?.fieldData?.charges, "pink-pill")}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        );
                    })()}
                </div>
            )}
            {modalData && (
                <Modal onClose={() => setModalData(null)}>
                    <div className="modal-header">
                        <button
                            className="close-modal-btn"
                            onClick={() => setModalData(null)}             // cross button
                        >
                            ✕

                        </button></div>

                    <A3PackDetails item={[modalData]} showMaxScreen={true} setIsShowMaximumChat={setIsShowMaximumChat}/>
                    
                </Modal>
      )}
        </div>
    );
};

export default SetupBox;
